import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { setHasNoData } from "../Directory/directorySlice";

export const fetchRuleDependencyData = createAsyncThunk(
  "ruleDependencies/fetchRuleDependencyData",
  async ({ url, config }, { dispatch }) => {
    const response = await axios.get(url, config);
    const data = response.data.data;

    if (!data || data.length === 0) {
      dispatch(setHasNoData(true));
    } else {
      dispatch(setHasNoData(false));
    }
    return data;
  }
);

const initialState = {
  ruleDependencies: [],
  status: "idle",
  loading: true,
  error: null,
};

const ruleDependencySlice = createSlice({
  name: "ruleDependencies",
  initialState,
  reducers: {
    addRuleDependency: (state, action) => {
      state.ruleDependencies.push(action.payload);
    },

    updateRuleDependency: (state, action) => {
      const { id, updatedData } = action.payload;
      const index = state.ruleDependencies.findIndex((dep) => dep.id === id);
      if (index !== -1) {
        state.ruleDependencies[index] = { ...updatedData };
      }
    },

    deleteRuleDependency: (state, action) => {
      const id = action.payload;
      state.ruleDependencies = state.ruleDependencies.filter((dep) => dep.id !== id);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchRuleDependencyData.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchRuleDependencyData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ruleDependencies = action.payload;
        state.loading = false;
      })
      .addCase(fetchRuleDependencyData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { addRuleDependency, updateRuleDependency, deleteRuleDependency } =
  ruleDependencySlice.actions;

export default ruleDependencySlice.reducer;
